import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "p2w-cookie-consent-v1";

export function getCookieConsent() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export default function CookieBanner() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const c = getCookieConsent();
        if (!c) setOpen(true);
    }, []);

    const accept = (mode) => {
        const value = {
            mode, // "all" | "essential"
            analytics: mode === "all",
            preferences: mode === "all",
            essential: true,
            date: new Date().toISOString(),
        };
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
        } catch { /* noop */ }
        setOpen(false);
    };

    if (!open) return null;

    return (
        <div
            data-testid="cookie-banner"
            role="dialog"
            aria-live="polite"
            aria-label="Consentimiento de cookies"
            className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60]"
        >
            <div className="rounded-2xl border border-p2w-line bg-p2w-elevated/95 backdrop-blur-md shadow-2xl p-5 relative">
                <button
                    onClick={() => accept("essential")}
                    aria-label="Cerrar"
                    className="absolute top-3 right-3 text-p2w-gray hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p2w-green rounded-sm"
                >
                    <X className="w-4 h-4" />
                </button>
                <div className="flex items-center gap-2 text-p2w-green">
                    <Cookie className="w-4 h-4" />
                    <span className="text-[10px] uppercase tracking-[0.2em] font-sora font-bold">Cookies</span>
                </div>
                <p className="mt-2 text-sm text-white/90 leading-relaxed">
                    Usamos cookies esenciales para que la plataforma funcione y, opcionalmente, analíticas para mejorar tu experiencia.
                    Puedes ver el detalle en nuestra{" "}
                    <Link to="/legal/cookies" data-testid="cookie-banner-policy-link" className="text-p2w-green underline hover:no-underline">
                        Política de cookies
                    </Link>.
                </p>
                <div className="mt-4 flex flex-col sm:flex-row gap-2">
                    <Button
                        onClick={() => accept("all")}
                        data-testid="cookie-accept-all"
                        className="bg-p2w-green text-p2w-green-fg hover:bg-p2w-green/90 font-semibold flex-1"
                    >
                        Aceptar
                    </Button>
                    <Button
                        onClick={() => accept("essential")}
                        data-testid="cookie-reject-non-essential"
                        variant="outline"
                        className="border-p2w-line bg-transparent text-white hover:bg-p2w-surface hover:text-white flex-1"
                    >
                        Rechazar no esenciales
                    </Button>
                </div>
            </div>
        </div>
    );
}
